import React, { useState } from "react";
import PropTypes from "prop-types";
import FormAccordion from "../../../components/Form/FormAccordion";
import { TextAreaField } from "../../../components/Form/FormComponents";
import ActionSideBar from "../partials/ActionSideBar";
import { LeaseInformAsset, LeaseeInformation } from "../partials/FormFields";
import { StyledForm } from "../../../components/Form/FormComponents.styled";
import { Box, Grid, Typography } from "@mui/material";
import { RequestsOnAsset } from "./QuickLeaseAssetForm";
import { getAssetRegPaymentStatus, getInsurancePaymentStatus } from "../../logistics/utils";
// import { useParams } from "react-router-dom";

const InvestorAssetForm = ({ leaseData, setLeaseData, updateLeaseObject }) => {
	// let { category } = useParams();
	const [formData, setFormData] = useState(leaseData);
	const [action, setAction] = useState("view");
	const isEditable = action === "edit";

	const handleInputChange = (e) => {
		setFormData({ ...formData, [e.target.name]: e.target.value });
	};

	const handleCancel = () => {
		setFormData(leaseData);
		setAction("view");
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		// console.log(formData);
		setLeaseData(formData);
		updateLeaseObject(formData);
	};

	const { paymentStatus } = getAssetRegPaymentStatus(leaseData);
	const { paymentStatus: insurancePaymentStatus } = getInsurancePaymentStatus(leaseData);

	return (
		<StyledForm onSubmit={handleSubmit}>
			<ActionSideBar leaseData={formData} handleCancel={handleCancel} />

			<div className='RightSection'>
				<FormAccordion title='Lease Information' open={true}>
					<div className='grid grid-cols-3 gap-3'>
						<LeaseInformAsset
							formData={formData}
							isEditable={isEditable}
							handleInputChange={handleInputChange}
							paymentStatus={paymentStatus}
							insurancePaymentStatus={insurancePaymentStatus}
						/>
					</div>
				</FormAccordion>

				<FormAccordion title='Product description'>
					<div className='form-group'>
						<TextAreaField
							name='product_desc'
							value={formData?.description || formData?.productId.description}
						/>
					</div>
				</FormAccordion>

				<FormAccordion title='Key features'>
					<div className='form-group'>
						<TextAreaField
							name='product_features'
							value={formData?.keyFeatures && formData?.keyFeatures?.replace(/;/g, "<br/>")}
						/>
					</div>
				</FormAccordion>

				<FormAccordion title='Product specifications'>
					<div className='form-group'>
						<TextAreaField
							name='product_specs'
							value={formData?.specifications && formData?.specifications?.replace(/;/g, "<br/>")}
						/>
					</div>
				</FormAccordion>

				<FormAccordion title='Leasor’s Information'>
					<LeaseeInformation formData={formData} />
				</FormAccordion>

				{/* <FormAccordion title='ID card'>
					<div className='form-group'>
						<FileGroup name='idCard' value={formData?.userId?.idCard} />
					</div>
				</FormAccordion> */}

				{/* <FormAccordion title='Utility bill'>
					<div className='form-group'>
						<FileGroup name='utilityBill' value={formData?.userId?.utilityBill} />
					</div>
				</FormAccordion> */}
				{leaseData?.status === "active" && (
					<FormAccordion title='Requests on Asset'>
						<Box
							sx={{
								backgroundColor: "#eff8f9",
								padding: "14px",
								border: "1px solid #b8c8cf",
								borderRadius: "5px",
								fontSize: "15px",
							}}>
							{leaseData?.usersRequest?.length > 0 ? (
								<div>
									<Grid container spacing={3} sx={{ fontWeight: 500, maxWidth: "87%" }} marginBottom={1}>
										<Grid item xs={4}>
											Transaction ID
										</Grid>
										<Grid item xs={4}>
											Name of Leasee
										</Grid>
										<Grid item xs={4}>
											Status
										</Grid>
									</Grid>
									{leaseData.usersRequest.map((request) => (
										<RequestsOnAsset key={request.transactionId} request={request} />
									))}
								</div>
							) : (
								<Typography sx={{ fontWeight: 500, fontSize: "inherit" }}>No requests available</Typography>
							)}
						</Box>
					</FormAccordion>
				)}
			</div>
		</StyledForm>
	);
};

// Props Validation
InvestorAssetForm.propTypes = {
	leaseData: PropTypes.object,
	setLeaseData: PropTypes.func,
	updateLeaseObject: PropTypes.func,
};

export default InvestorAssetForm;
